import { render } from "./App.vue?vue&type=template&id=46a40abc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=46a40abc&lang=css"

import exportComponent from "C:\\Users\\Italo\\Proyectos\\Vuejs\\b\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__